import { render, staticRenderFns } from "./SorteosNewOrEdit.vue?vue&type=template&id=400d1390"
import script from "./SorteosNewOrEdit.vue?vue&type=script&lang=js"
export * from "./SorteosNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports